export const items = {
    "name": "Playlist",
    "publishedDate": "2025-06-05T10:28:55.000Z",
    "items": [
        {
            "_id": "6wvdyDfjAp",
            "type": "lilanews",
            "value": {
                "publishedDate": "2025-06-05T01:38:58.000Z",
                "modificatedAt": "2025-06-05T10:41:08.000Z",
                "product": "clarin",
                "url": "/politica/duro-reves-gobierno-diputados-dio-media-sancion-aumento-jubilados-amenaza-rechazar-posible-veto-milei_0_6wvdyDfjAp.html",
                "sections": [
                    {
                        "_id": 2,
                        "name": "Política",
                        "nsSite": "clarin-politica"
                    }
                ],
                "title": "Duro revés para el Gobierno: Diputados dio media sanción al aumento para los jubilados y a la prórroga de la moratoria",
                "summary": "<ul><li>Se trata de una suba de 7,2 % para los jubilados y una actualización del bono que llega a los $110 mil.</li><li>La propuesta fue aprobada con 142 votos a favor, 67 en contra y 19 abstenciones.</li></ul>",
                "authors": [
                    {
                        "slug": "gustavo-beron",
                        "hasVisiblePage": true,
                        "category": "5",
                        "imageUrl": "http://images.clarin.com/authors/gustavo-beron1___62bdf252d9846d0018678ac2.png",
                        "email": "gberon@clarin.com",
                        "twitter": "@gberon10",
                        "shortBiography": "Redactor de la sección Política",
                        "biography": "<p>Redactor de la sección Política</p> ",
                        "name": "Gustavo Berón",
                        "_id": "19679"
                    }
                ],
                
                "body": [
                        {
                            "id": "paragraph0",
                            "type": "text",
                            "value": "<p>Sin el apoyo de los gobernadores, el Gobierno sufrió este miércoles una dura derrota en Diputados, donde la oposición dio media sanción y giró al Senado un proyecto que <strong>aumenta 7,2 % las jubilaciones, actualiza el bono de emergencia y transforma en ley&nbsp; la fórmula de actualización de los haberes</strong> que el presidente Javier Milei sacó por un DNU.</p>",
                            "droppableId": "1642569651"
                        }
                    ],
                "related": {
                    "images": [
                        {
                            "epigraphe": "La oposición le dio un golpe al Gobierno al aprobar un aumento para los jubilados. Foto: Federico López Claro.",
                            "type": "image",
                            "value": {
                                "entityId": "67359684_0",
                                "author": "FTP CLARIN",
                                "title": "Sesión en Diputados por temas de discapacidad y jubilaciones Paula Penacca german Martinez bloque Up Foto Federico Lopez Claro - FTP CLARIN IMG_4007.JPG Z RGonzalez gonzalez",
                                "clippings": [
                                    {
                                        "url": "/2025/06/04/BYcTdcXRR_600x290__1.jpg",
                                        "_id": "rectangle_lg",
                                        "dimensions": {
                                            "width": 600,
                                            "height": 290
                                        }
                                    },
                                    {
                                        "url": "/2025/06/04/BYcTdcXRR_290x140__1.jpg",
                                        "_id": "rectangle_sm",
                                        "dimensions": {
                                            "width": 290,
                                            "height": 140
                                        }
                                    },
                                ]
                            },
                            "_id": "BYcTdcXRR"
                        }
                    ],
                },
            },
            "title": "Duro revés para el Gobierno: Diputados dio media sanción al aumento para los jubilados y amenaza con rechazar el posible veto de Milei"
        },
        {
            "_id": "fruurWh8Ef",
            "type": "lilanews",
            "value": {
                "product": "clarin",
                "url": "/politica/vialidad-corte-rechazo-recusacion-cristina-kirchner-ricardo-lorenzetti_0_fruurWh8Ef.html",
                "title": "Vialidad: La Corte rechazó de plano la recusación de Cristina Kirchner contra Ricardo Lorenzetti",
                "summary": "<ul><li>Lo decidieron Horacio Rosatti, Carlos Rosenkrantz y el propio recusado. Consideraron que actitudes y declaraciones del juez no implicaban adelantar opinión sobre la cuestión de fondo. Esto los habilita a seguir tratando el recurso de la ex presidenta y definir si confirma la condena con la participación de Lorenzetti.</li></ul>",
                "authors": [
                    {
                        "_id": "15285",
                        "name": "Daniel Santoro",
                        "shortBiography": "Periodista de investigación y editor judicial",
                        "twitter": "@dsantoro59",
                        "email": "dsantoro@clarin.com",
                        "imageUrl": "http://images.clarin.com/authors/daniel-santoro___635c6b04a9ef0b001a46ae0a.png",
                        "category": "4",
                        "slug": "daniel-santoro"
                    }
                ],
                "body": [{
                    "id": "paragraph0",
                    "type": "text",
                    "value": "<p>La Corte Suprema <strong>rechazó este miércoles por inadmisible </strong>la recusación de Cristina Kirchner contra el juez Ricardo Lorenzetti en el recurso de queja contra su condena a 6 años de prisión en la causa Vialidad.</p>",
                    "droppableId": "7344203993"
                    },],
                "related": {
                    "images": [
                        {
                            "epigraphe": "Ricardo Lorenzetti estuvo de invitado en un programa de A24.",
                            "type": "image",
                            "value": {
                                "entityId": "10718653_1",
                                "author": "Foto",
                                "title": "Ricardo Lorenzetti estuvo de invitado en un programa de A24.",
                                "clippings": [
                                    {
                                        "url": "/2025/05/01/8pLU6EoPP_600x290__1.jpg",
                                        "_id": "rectangle_lg",
                                        "dimensions": {
                                            "width": 600,
                                            "height": 290
                                        }
                                    },
                                    {
                                        "url": "/2025/05/01/8pLU6EoPP_290x140__1.jpg",
                                        "_id": "rectangle_sm",
                                        "dimensions": {
                                            "width": 290,
                                            "height": 140
                                        }
                                    },
                                ]
                            }
                        }
                    ]
                },
            },
            "publishedDate": "2025-06-04T19:29:18.000Z",
            "modificatedAt": "2025-06-04T21:51:35.000Z",
            "createdAt": null,
            "createdBy": null
        },
        {
            "_id": "566jZqwupC",
            "type": "lilanews",
            "value": {
                "product": "clarin",
                "url": "/mundo/serie-fotos-satelitales-revela-destrozos-aviones-rusia-atacados-drones-ucrania_0_566jZqwupC.html",
                "title": "La serie de fotos satelitales que revela los destrozos en los aviones de Rusia atacados por drones de Ucrania ",
                "summary": "<ul><li>Son imágenes de la base aérea de Belaya, en Siberia, uno de los cuatro aeródromos saboteados. </li><li>Quedaron destruidos o dañados 41 aviones de combate rusos. Kiev estimó que representan cerca del 35 % de la flota rusa.</li></ul>",
                "keywords": "serie,fotos,satelitales,revela,destrozos,aviones,rusia,atacados,drones,ucrania",
            "body": [
            {
                "id": "paragraph0",
                "type": "text",
                "value": "<p>Todavía continúan las repercusiones por el <a href='https://www.clarin.com/mundo/paso-paso-audaz-operacion-telarana-drones-ucrania-destruyo-40-aviones-rusos_0_Yw0e7dvTGg.html' target='_blank title='sabotaje con drones' alt='sabotaje con drones'>sabotaje con drones</a> mediante el que Ucrania destruyó más de cuarenta aviones de combate rusos en cuatro bases aéreas, entre ellas una ubicada en Siberia. En las últimas horas se difundieron imágenes satelitales que dan cuenta de la magnitud de la 'Operación Telaraña', planeada durante un año y medio, que devastó casi un tercio de los bombarderos rusos.</p>",
                "droppableId": "8886131247",
            }],
            "related": {
                "images": [
                    {
                        "epigraphe": "Los aviones bombarderos rusos que fueron destruidos por un sabotaje ucraniano en Siberia. Foto Maxar Technologies via AP",
                        "type": "image",
                        "value": {
                                "entityId": "67358016_0",
                                "author": "<Authors>",
                                "title": "This satellite image provided by Maxar Technologies shows damage after a Ukrainian drone attack targeted the Belaya Air Base in the Irkutsk region of eastern Siberia in Russia captured on June 4, 2025. (Maxar Technologies via AP)",
                            "clippings": [
                                {
                                    "url": "/2025/06/04/ENrEagHMy_600x290__1.jpg",
                                    "_id": "rectangle_lg",
                                    "dimensions": {
                                        "width": 600,
                                        "height": 290
                                    }
                                },
                                {
                                    "url": "/2025/06/04/ENrEagHMy_290x140__1.jpg",
                                    "_id": "rectangle_sm",
                                    "dimensions": {
                                        "width": 290,
                                        "height": 140
                                    }
                                },
                            ]
                        },
                        "_id": "ENrEagHMy"
                    }
                ]
            },
            "publishedDate": "2025-06-04T23:44:31.000Z",
            "modificatedAt": "2025-06-05T11:44:38.000Z",
            "createdAt": null,
            "createdBy": null
            },
            "title": "La serie de fotos satelitales que revela los destrozos en los aviones de Rusia atacados por drones de Ucrania "
        },
        {
            "_id": "EBSEYuVLax",
            "type": "lilanews",
            "value": {
            "product": "clarin",
            "url": "/sociedad/pruebas-aprender-revelan-nivel-critico-matematica-estudiantes-secundarios_0_EBSEYuVLax.html",
            "title": "Pruebas Aprender: revelan un nivel crítico en Matemática en los estudiantes secundarios",
            "summary": "<ul><li>Hoy se dieron a conocer los resultados de la muestra censal realizada en 2024 a alumnos de 5° y 6° año.</li><li>Sólo el 14,2% alcanzó el nivel satisfactorio en esta materia. En Lengua, las cifras fueron mejores.</li></ul>",
            "authors": [
            {
            "_id": "15060",
            "name": "Emilia Vexler",
            "biography": "<p>Redactora de la sección Sociedad. Se recibió de Licenciada en Comunicación Social en la Universidad de Buenos Aires y cursó la Maestría en Periodismo de Clarín y la Universidad de San Andrés. Obtuvo el Diploma de Honor en Periodismo del Instituto Tecnológico de Monterrey, México, y realizó el entrenamiento en Cambio Climático de The Associated Press en la Universidad de Oxford, Inglaterra. Hace más de una década que escribe en el diario historias de actualidad, de salud y de tendencias.</p>",
            "shortBiography": "Redactora de la sección Sociedad",
            "twitter": "@EmilyVex",
            "email": "evexler@clarin.com",
            "imageUrl": "http://images.clarin.com/authors/emilia-vexler___633f56d7d111ad001b3f460d.png",
            "category": "5",
            "slug": "emilia-vexler"
            }
            ],
            "keywords": "pruebas,aprender,revelan,nivel,critico,matematica,estudiantes,secundarios",

            "body": [{
            "id": "paragraph0",
            "type": "text",
            "value": "<p>Desde hace años que el rendimiento de los estudiantes de las secundarias de Argentina <strong>viene retrocediendo en Matemática</strong>. Pero ahora ese saber está en <strong>niveles críticos</strong>. Sólo el 14,2% alcanzó un nivel satisfactorio en esa materia, según los resultados de las <strong>Prueba Aprender Secundaria 2024</strong>, que se tomaron el año pasado en chicos y chicas de 5° y 6° año.</p>",
            "droppableId": "8669240989"
            },],
            "related": {
            "images": [
            {
            "epigraphe": "Las pruebas Aprender son censales y se hacen en todo el país. Foto Telam / Archivo ",
            "type": "image",
            "value": {
            "entityId": "9139979_1",
            "author": null,
            "title": "Río Negro Operativo Aprender Foto Telam",
            "clippings": [

            {
            "url": "/2022/06/21/Ba61jf8DO_290x140__1.jpg",
            "_id": "rectangle_sm",
            "dimensions": {
            "width": 290,
            "height": 140
            }
            },
            {
            "url": "/2022/06/21/Ba61jf8DO_600x290__1.jpg",
            "_id": "rectangle_lg",
            "dimensions": {
            "width": 600,
            "height": 290
            }
            },
            ],

            },
            "_id": "Ba61jf8DO",

            }
            ]
            },
            "publishedDate": "2025-06-04T12:59:22.000Z",
            "modificatedAt": "2025-06-04T18:29:08.000Z",
            "createdAt": null,
            "createdBy": null
            },
            "title": "Pruebas Aprender: revelan un nivel crítico en Matemática en los estudiantes secundarios"
            },
            {
"_id": "6QJXCuJvfu",
"type": "lilanews",
"value": {
"product": "clarin",
"url": "/economia/dolares-colchon-flexibilizan-controles-lavado-comprar-inmuebles-us-198000_0_6QJXCuJvfu.html",
"title": "Dólares del colchón: flexibilizan controles de lavado para comprar inmuebles por menos de US$ 198.000",
"summary": "<ul><li>En el caso de los autos será por menos de US$ 42.300</li><li>La UIF firmó una resolución con los nuevos umbrales. Este jueves saldrá en el Boletín Oficial.</li><li>Los bancos esperaban la señal para sumarse al nuevo esquema.</li></ul><p><br></p>",
"authors": [
{
"_id": "15773",
"name": "Juan Manuel Barca",
"biography": "<p>Redactor de la sección Economía. Es licenciado en Ciencias de la Comunicación Social (UBA) y realizó la Maestría de Periodismo de Clarín y la Universidad de San Andrés en 2016. Antes, fue redactor en Reuters, Página/12, iProfesional. Fue becado en la Universidad de Massachusetts en EE.UU. por el programa Jóvenes Líderes de la comisión Fulbright.</p>",
"shortBiography": "Redactor de la sección Economía",
"twitter": "@juanmanuelbarca",
"instagram": "@juanmbarca",
"email": "jbarca@clarin.com",
"imageUrl": "http://images.clarin.com/authors/juan-manuel-barca___62ebd9d9d40b3f0019538718.png",
"category": "5",
"hasVisiblePage": true,
"slug": "juan-manuel-barca"
}
],
"keywords": "dolares,colchon,flexibilizan,controles,lavado,comprar,inmuebles,us,198000",
"body": [{
"id": "paragraph0",
"type": "text",
"value": "<p>Dos semanas después de los anuncios de Luis Caputo para que los argentinos saquen los dólares del colchón sin justificarlos, el Gobierno terminó de publicar las últimas medidas del plan de reparación histórica de los ahorros. Se trata de la <strong>flexibilización de controles de lavado para la compra de autos, propiedades y transacciones en efectivo como con depósitos</strong> bancarios, todas operaciones reguladas por la Unidad de Información Financiera (UIF).</p>",
"droppableId": "670419115"
},],
"related": {
"images": [
{
"epigraphe": "Paul Starc, titular de UIF.",
"type": "image",
"value": {
"entityId": "10570681_1",
"author": "FTP CLARIN",
"title": "- FTP CLARIN Paulo Paul Starc fiscal federal de San martín designado como nuevo presidente la UIF.jpg Z Invitado",
"clippings": [
{
"url": "/2025/01/16/ZohOVGLcq_600x290__1.jpg",
"_id": "rectangle_lg",
"dimensions": {
"width": 600,
"height": 290
}
},
{
"url": "/2025/01/16/ZohOVGLcq_290x140__1.jpg",
"_id": "rectangle_sm",
"dimensions": {
"width": 290,
"height": 140
}
},
]
},
"_id": "ZohOVGLcq"
}
]
},
"publishedDate": "2025-06-04T23:17:35.000Z",
"modificatedAt": "2025-06-05T12:20:19.000Z",
"createdAt": null,
"createdBy": null
},
"title": "Dólares del colchón: flexibilizan controles de lavado para comprar inmuebles por menos de US$ 198.000"
}
]
}